/**
 * Created by razial on 21.09.2026.
 */

cleverapps.overrideStyles(cleverapps.styles.ChestTimeMissionWindow, {
    contentPadding: [{
        left: 0,
        right: 0
    }, {
        left: 0,
        right: 500
    }, {
        left: 0,
        right: 600
    }],

    description: {
        y: { align: "center", dy: -550 }
    },

    pack: {
        x: { align: "center", dx: 900 },
        y: { align: "center", dy: -100 },

        title: {
            x: { align: "center" },
            y: { align: "center", dy: 0 },
            noBg: true,

            text: {
                x: { align: "center" },
                y: { align: "center", dy: 120 },
                width: 400
            }
        },

        energyReward: {
            x: { align: "center" },
            y: { align: "center", dy: -220 },

            icon: {
                scale: 0.8
            }
        },

        buyPackButton: {
            x: { align: "center" },
            y: { align: "center", dy: -350 },
            width: 330,
            height: 110
        },

        cooldown: {
            button: {
                x: { align: "center" },
                y: { align: "center", dy: -405 }
            },
            timer: {
                x: { align: "center" },
                y: { align: "center", dy: -302 },
                margin: 8,
                icon: {
                    scale: 1.2,
                    dx: 4,
                    dy: -4
                }
            }
        }
    }
});
